import { render, staticRenderFns } from "./Clarification.vue?vue&type=template&id=def98240&scoped=true"
import script from "./Clarification.vue?vue&type=script&lang=js"
export * from "./Clarification.vue?vue&type=script&lang=js"
import style0 from "./Clarification.vue?vue&type=style&index=0&id=def98240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def98240",
  null
  
)

export default component.exports